import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'MNC Play Addon Purchase' }
  }
]

const router = new VueRouter({
  routes,
  mode: 'history'
})

router.afterEach((to) => {
  Vue.nextTick(() => {
      document.title = to.meta.title
  })
})

export default router